// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:300&display=swap&subset=cyrillic);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-page {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);
  display: flex;
}

.menu {
  position: relative;
  width: 300px;
  display: flex;
  flex-direction: column;
  background: white;
  border-right: 1px solid #e7e7e7;
  color: white;
}
.menu-avatar {
  width: 300px;
  height: 55px;
  padding: 6px 10px 10px 20px;
  background: #242736;
  font-size: 15px;
}
.menu .list {
  height: 55px;
  display: flex;
  align-items: center;
  color: black;
  cursor: pointer;
  border-bottom: 1px solid #e7e7e7;
  margin: 0 20px;
}
.menu .list:hover {
  color: #0078d7;
}
.menu .list.active {
  color: #0078d7;
}
.menu .list .icon {
  width: 24px;
  height: 24px;
}
.menu .list .icon img {
  color: #4f589e;
  width: 100%;
  height: 100%;
}
.menu .list .title {
  margin-left: 10px;
  font-family: "Rubik", sans-serif;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
}
.menu .sub-menu {
  background-color: #fafafa;
}
.menu .sub-menu .sub-list {
  margin: 0 20px 0 40px;
  height: 45px;
  border-bottom: 1px dashed #e7e7e7;
}
.menu .sub-menu .sub-list:last-child {
  border-bottom: 1px solid #e7e7e7;
}
.menu .exit {
  position: absolute;
  cursor: pointer;
  padding-top: 5px;
  color: #01c4f5;
  font-size: 13px;
}

.section {
  height: 100%;
  flex: 1;
  width: calc(100% - 300px);
}

.arrow {
  margin-left: auto;
  margin-right: 0;
  transition: transform 0.3s ease;
}
.arrow.rotated {
  transform: rotate(90deg);
}`, "",{"version":3,"sources":["webpack://./src/app/pages/main/main.component.scss"],"names":[],"mappings":"AAEA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,gDAAA;EACA,aAAA;AAAF;;AAGA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,+BAAA;EACA,YAAA;AAAF;AAEE;EACE,YAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;AAAJ;AAGE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gCAAA;EACA,cAAA;AADJ;AAGI;EACE,cAAA;AADN;AAII;EACE,cAAA;AAFN;AAKI;EACE,WAAA;EACA,YAAA;AAHN;AAKM;EACE,cAAA;EACA,WAAA;EACA,YAAA;AAHR;AAOI;EACE,iBAAA;EACA,gCAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;AALN;AASE;EACE,yBAAA;AAPJ;AASI;EACE,qBAAA;EACA,YAAA;EACA,iCAAA;AAPN;AASM;EACE,gCAAA;AAPR;AAYE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAVJ;;AAcA;EACE,YAAA;EACA,OAAA;EACA,yBAAA;AAXF;;AAcA;EACE,iBAAA;EACA,eAAA;EACA,+BAAA;AAXF;AAaE;EACE,wBAAA;AAXJ","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Roboto:300&display=swap&subset=cyrillic');\r\n\r\n.main-page {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0 auto;\r\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.75);\r\n  display: flex;\r\n}\r\n\r\n.menu {\r\n  position: relative;\r\n  width: 300px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: white;\r\n  border-right: 1px solid #e7e7e7;\r\n  color: white;\r\n\r\n  &-avatar {\r\n    width: 300px;\r\n    height: 55px;\r\n    padding: 6px 10px 10px 20px;\r\n    background: #242736;\r\n    font-size: 15px;\r\n  }\r\n\r\n  .list {\r\n    height: 55px;\r\n    display: flex;\r\n    align-items: center;\r\n    color: black;\r\n    cursor: pointer;\r\n    border-bottom: 1px solid #e7e7e7;\r\n    margin: 0 20px;\r\n\r\n    &:hover {\r\n      color: #0078d7;\r\n    }\r\n\r\n    &.active {\r\n      color: #0078d7;\r\n    }\r\n\r\n    .icon {\r\n      width: 24px;\r\n      height: 24px;\r\n\r\n      img {\r\n        color: #4f589e;\r\n        width: 100%;\r\n        height: 100%;\r\n      }\r\n    }\r\n\r\n    .title {\r\n      margin-left: 10px;\r\n      font-family: 'Rubik', sans-serif;\r\n      text-transform: uppercase;\r\n      font-weight: bold;\r\n      font-size: 14px;\r\n    }\r\n  }\r\n\r\n  .sub-menu {\r\n    background-color: #fafafa;\r\n\r\n    .sub-list {\r\n      margin: 0 20px 0 40px;\r\n      height: 45px;\r\n      border-bottom: 1px dashed #e7e7e7;\r\n\r\n      &:last-child {\r\n        border-bottom: 1px solid #e7e7e7;\r\n      }\r\n    }\r\n  }\r\n\r\n  .exit {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    padding-top: 5px;\r\n    color: #01c4f5;\r\n    font-size: 13px;\r\n  }\r\n}\r\n\r\n.section {\r\n  height: 100%;\r\n  flex: 1;\r\n  width: calc(100% - 300px);\r\n}\r\n\r\n.arrow {\r\n  margin-left: auto;\r\n  margin-right: 0;\r\n  transition: transform 0.3s ease;\r\n\r\n  &.rotated {\r\n    transform: rotate(90deg);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
